<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import ModalImportDiklat from "./modal-import-diklat.vue";

export default {
  page: {
    title: "Master Diklat",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    ModalImportDiklat,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "idverif_judul_diklat",
      },
      {
        width: "auto",
        label: "Judul Diklat",
        name: "judul_diklat",
      },
      {
        width: "200px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    // Get hak akses
    const menu = "Master Diklat";

    return {
      title: menu,
      isWrite: 1,
      showModal: false,
      showModalImport: false,
      isEdit: false,
      selected_id: "",
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idverif_judul_diklat", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "idverif_judul_diklat",
        dir: "desc",
        filter: {
          active_flag: 1,
        },
      },

      form: {
        nama_diklat: "",
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  async mounted() {
    await this.getDataTable();
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/diklat",
    ) {
      this.loadingTable = true;

      var config = {
        method: "get",
        url: url,
        params: this.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data_fix.data;
            this.configPagination(response_data_fix);
            this.currentTablePage = response_data_fix.current_page;
            this.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          this.loadingTable = false;
          console.log(errors);
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage(url) {
      if (!url) return;
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable();
    },
    resetForm() {
      this.form = {
        nama_diklat: "",
      };
      this.selected_id = "";
    },
    create() {
      this.resetForm();
      this.isEdit = false;
      this.showModal = true;
    },
    edit(data) {
      this.isEdit = true;
      this.selected_id = data.idverif_judul_diklat;
      this.form = {
        kode_diklat: data.kode_diklat,
        nama_diklat: data.nama_diklat,
        deskripsi: data.deskripsi,
      };
      this.showModal = true;
    },
    save() {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION + "verifikasi/diklat";
      let method = "post";

      if (this.isEdit) {
        url += "/" + this.selected_id;
        method = "put";
      }

      Swal.fire({
        title: "Sedang memproses data...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      axios({
        method: method,
        url: url,
        data: this.form,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          if (response.data.meta.code == 200) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: response.data.meta.message,
            });
            this.showModal = false;
            this.getDataTable();
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          let message = "Terjadi kesalahan";

          const metaMessage = error?.response?.data?.meta?.message;
          const validationErrors = error?.response?.data?.data?.error;

          if (
            metaMessage === "Validation failed" &&
            Array.isArray(validationErrors)
          ) {
            message = `
              <ul style="text-align:left;">
                ${validationErrors.map((err) => `<li>${err}</li>`).join("")}
              </ul>
            `;
          } else if (metaMessage) {
            message = metaMessage;
          }

          Swal.fire({
            icon: "error",
            title: "Oops...",
            html: message,
          });
        });
    },
    changeStatus(data) {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/diklat/" +
        data.idverif_judul_diklat +
        "/status";
      let method = "put";

      Swal.fire({
        title: "Apakah anda yakin?",
        text:
          data.active_flag == 1
            ? "Data akan dinonaktifkan!"
            : "Data akan diaktifkan kembali!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    deleteData(data) {
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/diklat/" +
        data.idverif_judul_diklat;
      let method = "delete";

      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Data akan dihapus secara permanen!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <!-- <div class="card-title">List Data</div> -->
              </div>
              <div class="col-md-6">
                <div class="text-end">
                  <button
                    class="btn btn-info btn-sm mx-2"
                    @click="showModalImport = true"
                    v-if="isWrite || isWrite == 1"
                  >
                    <i class="fa fa-file-excel me-1"></i> Import Excel
                  </button>
                  <button
                    class="btn btn-success btn-sm"
                    @click="create()"
                    v-if="isWrite || isWrite == 1"
                  >
                    <i class="fa fa-plus me-1"></i> Tambah
                  </button>
                </div>
              </div>
              <div class="row mt-2">
                <hr />
                <div class="form-group col-md-3">
                  <label for="filterStatus">Status</label>
                  <select
                    class="form-control"
                    id="filterStatus"
                    v-model="tableFilter.filter.active_flag"
                    @change="getDataTable()"
                  >
                    <option value="1">Aktif</option>
                    <option value="0">Tidak Aktif</option>
                  </select>
                </div>
              </div>
              <div class="row mt-2">
                <hr />
                <div class="col-12">
                  <table class="mb-2">
                    <tr>
                      <td>Show</td>
                      <td>
                        <select
                          class="form-control form-control-sm"
                          id="showpaginatetable"
                          v-model="tableFilter.per_page"
                          @change="getDataTable()"
                        >
                          <option value="10">10</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                          <option value="500">500</option>
                        </select>
                      </td>
                      <td>Entries</td>
                    </tr>
                  </table>
                </div>

                <datatable
                  :columns="columns"
                  :sortKey="sortKey"
                  :sortOrders="sortOrders"
                  @sort="sortBy"
                >
                  <tbody>
                    <tr v-if="loadingTable">
                      <td class="text-center" colspan="99">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                      </td>
                    </tr>
                    <tr v-else-if="table_data == ''">
                      <td class="text-center" colspan="99">
                        Data Tidak Tersedia
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(row_data, key_data) in table_data"
                      :key="key_data"
                    >
                      <td>{{ key_data + pagination.from }}</td>
                      <td>
                        {{ row_data.nama_diklat }}
                      </td>
                      <td class="text-center">
                        <div class="btn-group">
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            v-if="isWrite || isWrite == 1 && row_data.active_flag == 1"
                            v-on:click="edit(row_data)"
                          >
                            <i class="fa fa-edit"></i> Edit
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            v-if="isWrite || isWrite == 1 && row_data.active_flag == 1"
                            @click="changeStatus(row_data)"
                          >
                            <i class="fa fa-trash"></i> Disable
                          </button>
                          <button
                            type="button"
                            class="btn btn-warning btn-sm"
                            v-if="isWrite || isWrite == 1 && row_data.active_flag == 0"
                            @click="changeStatus(row_data)"
                          >
                            <i class="fa fa-recycle"></i> Enable
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            v-if="isWrite || isWrite == 1 && row_data.active_flag == 0"
                            v-on:click="deleteData(row_data)"
                          >
                            <i class="fa fa-trash"></i> Hapus
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </datatable>
              </div>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <b-modal
      v-model="showModal"
      :title="isEdit ? 'Edit Master Diklat' : 'Tambah Master Diklat'"
      title-class="text-black font-18"
      body-class="p-4"
      hide-footer
    >
      <form @submit.prevent="save">
        <div class="form-group mb-3">
          <label>Judul Diklat <span class="text-danger">*</span></label>
          <input
            v-model="form.nama_diklat"
            type="text"
            class="form-control"
            placeholder="Masukkan Judul Diklat"
            required
          />
        </div>
        <div class="text-end mt-4">
          <button
            type="button"
            class="btn btn-light me-1"
            @click="showModal = false"
          >
            Tutup
          </button>
          <button type="submit" class="btn btn-success">Simpan</button>
        </div>
      </form>
    </b-modal>

    <!-- Modal Import Excel -->
    <b-modal
      v-model="showModalImport"
      title="Import Data Master Diklat"
      title-class="text-black font-18"
      body-class="p-4"
      hide-footer
    >
      <ModalImportDiklat
        @refreshTable="
          showModalImport = false;
          getDataTable();
        "
      />
    </b-modal>
  </Layout>
</template>
